import React from 'react';
import homeIcon from '/assets/icons/home.svg';
import filetextIcon from '/assets/icons/filetext.svg';
import starIcon from '/assets/icons/star.svg';
import folderopenIcon from '/assets/icons/folderopen.svg';
import smartphoneIcon from '/assets/icons/smartphone.svg';
import mailIcon from '/assets/icons/mail.svg';
import brandImage from '/assets/brand/travel-rethinkways-brand.avif';

const placementData = [
    {
        id: 1,
        title: 'Homepage Visibility',
        description: 'Premium homepage placements designed for instant brand attention and high-impact visibility.',
        icon: homeIcon,
    },
    {
        id: 2,
        title: 'Editorial & Destination Features',
        description: 'Natural brand integration across travel stories, destination insights, and editorial experiences.',
        icon: filetextIcon,
    },
    {
        id: 3,
        title: 'Super Deals & Campaign Pages',
        description: 'Curated campaign visibility where travelers actively explore, compare, and plan journeys.',
        icon: starIcon,
    },
    {
        id: 4,
        title: 'Curated Travel Categories',
        description: 'Feature your brand across travel themes like luxury stays, honeymoon escapes, beaches, and international travel.',
        icon: folderopenIcon,
    },
    {
        id: 5,
        title: 'Social & Discovery Visibility',
        description: 'Engaging travel-focused content designed for discovery, interaction, and audience reach.',
        icon: smartphoneIcon,
    },
    {
        id: 6,
        title: 'Direct Traveler Engagement',
        description: 'Connect through personalized communication touchpoints including email and WhatsApp campaigns.',
        icon: mailIcon,
    }
];

const WhereBrandAppearsSection = () => {
    return (
        <section className="w-full bg-white py-0 md:py-10 px-4 sm:px-8 lg:px-12 font-sans overflow-visible">

            <div className="max-w-[1500px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">

                {/* --- Left Column: White Mode (Sticky) --- */}
                <div className="flex flex-col items-center lg:items-start text-center lg:text-left w-full max-w-xl mx-auto lg:mx-0 relative lg:sticky lg:top-32 self-start">

                    {/* Badge */}
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#d02525] border-gray-800 mb-5 sm:mb-6 shadow-sm mt-5">
                        <span className="text-white font-poppins text-[10px] sm:text-xs md:text-sm font-semibold tracking-widest uppercase">
                            Brand Visibility Across The Platform
                        </span>
                    </div>

                    {/* Main Headline */}
                    <h2 className="text-[24px] md:text-2xl sm:text-3xl lg:text-[50px] font-semibold text-black leading-tight lg:leading-[0.9] mb-4 sm:mb-1 tracking-tight whitespace-nowrap">
                        Where Your Brand Appears
                    </h2>

                    {/* Subtext */}
                    <div className="mb-8 lg:mb-1 mt-0 sm:mt-6 lg:mt-8">
                        <p className="space-y-4 sm:space-y-6 text-black text-[18px] sm:text-lg md:text-xl lg:text-2xl font-poppins leading-relaxed mb-1 sm:mb-10 lg:mb-12">
                            Showcase your brand across premium travel placements designed for visibility, discovery, and traveler engagement.
                        </p>
                    </div>

                    {/* Clean Image Element */}
                    <div className="relative w-full max-w-[600px] aspect-[4/3] rounded-[24px] lg:rounded-[32px] overflow-hidden">
                        <img
                            src={brandImage}
                            alt="Brand visibility and strategy"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

                {/* --- Right Column: Dark Mode Cards (Scrolling) --- */}
                <div className="relative w-full mt-0 lg:mt-0">
                    <div className="flex flex-col gap-4 sm:gap-5 lg:gap-8 pb-4">

                        {placementData.map((step) => {
                            return (
                                <div key={step.id} className="relative w-full flex items-center group">

                                    {/* Main Card Body */}
                                    <div className="relative w-full ml-0 md:ml-7 bg-[#000000] rounded-[20px] lg:rounded-[24px] p-4 sm:p-5 md:p-6 lg:p-1 pl-4 sm:pl-6 md:pl-14 lg:pl-10 pt-16 sm:pt-20 md:pt-6 pb-6 sm:pb-6 md:pb-0 font-poppins min-h-[160px] md:min-h-[180px] lg:min-h-[200px] flex flex-col justify-center">

                                        {/* Floating Icon Box: Scaled for mobile (w-8 h-8), restored for desktop (w-14 h-14) */}
                                        <div className="absolute top-4 left-4 sm:top-5 sm:left-5 md:top-1/2 md:-translate-y-1/2 md:-left-7 w-8 h-8 md:w-14 md:h-14 bg-[#d02525] border border-white/5 rounded-[14px] flex items-center justify-center z-10 shadow-lg transition-colors group-hover:bg-[#D02525]">
                                            <img
                                                src={step.icon}
                                                alt={step.title}
                                                className="w-4 h-4 md:w-6 md:h-6"
                                                style={{ filter: 'brightness(0) invert(1)' }}
                                            />
                                        </div>

                                        <h3 className={`text-[22px] sm:text-lg lg:text-[30px] font-poppins font-semibold text-white ${step.description ? 'mb-2 md:mb-3' : 'mb-0'}`}>
                                            {step.title}
                                        </h3>

                                        {step.description && (
                                            <p className="text-[18px] md:text-base lg:text-[24px] text-gray-300 leading-relaxed font-poppins">
                                                {step.description}
                                            </p>
                                        )}

                                    </div>

                                </div>
                            );
                        })}

                    </div>
                </div>

            </div>
        </section>
    );
};

export default React.memo(WhereBrandAppearsSection);